import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import CameraRetroIcon from "@rsuite/icons/legacy/CameraRetro";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { musicianDefaultURL } from "../../../components/CommonApis/CommonArtistApis";
import MessageSubHeading from "../../../components/CommonComponents/MessageSubHeading";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import { IoClose } from "react-icons/io5";
import { toast } from "react-toastify";
import { getItemToken } from "../../../Utils/localStorageUtils";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";

const PartnerMonetizationSettings = () => {

  const headers = getItemToken('access_token')
  const [formData, setFormData] = useState({
    viewcount_limit: "",
    views_amount: "",
    video_viewcount_limit: "",
  })

  const [formDataError, setFormDataError] = useState({})
  const [showOverlay, setShowOverlay] = useState(false);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [loading, setLoading] = useState(true)

  const viewCountInputRef = useRef(null);
  const ViewsAmountInputRef = useRef(null);
  const videoViewcountRef = useRef(null)

  const formValidation = () => {
    let formIsValid = true;
    if (!formData?.viewcount_limit) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        viewcount_limit: "Monetization view limit cannot be empty.",
      }));
      viewCountInputRef.current.focus();
      formIsValid = false;
    }
    // if (!formData?.views_amount) {
    //   setFormDataError((prevFormData) => ({
    //     ...prevFormData,
    //     views_amount: "View Amount cannot be empty.",
    //   }));
    //   ViewsAmountInputRef.current.focus();
    //   formIsValid = false;
    // }
    if (!formData?.video_viewcount_limit) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        video_viewcount_limit: "Video view limit cannot be empty.",
      }));
      videoViewcountRef.current.focus();
      formIsValid = false;
    }
    return formIsValid;
  }


  const handleStore = async () => {
    if (formValidation()) {
      await handleAdd();
    } else {
      console.log("Form validation failed ");
    }
  }



  const handleAdd = async () => {
    setShowOverlay(true);
    try {
      const formDataAdd = {};
      for (const key in formData) {
        if (['viewcount_limit', 'views_amount', 'video_viewcount_limit'].includes(key)) {
          formDataAdd[key] = formData[key];
        }
      }

      const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/Partner-monetization-setting/update`, formDataAdd, { headers: headers });
      const result = response?.data;
      if (result?.status) {
        setWithOutRefresh(!withOutRefresh)
        setShowOverlay(false);
        toast.success(result?.message)
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }
  }

  const EditData = async () => {
    const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/Partner-monetization-setting/index`, { headers: headers });
    const result = response?.data;
    const editResult = result?.PartnerMonetizationSettings;
    if (response?.data?.status) {
      setFormData(editResult)
      setLoading(false);
    }
    else {
      console.error(result?.message)
      setLoading(false);
    }
  };

  // function end
  useEffect(() => {
    EditData()
  }, [withOutRefresh]);

  const handleInput = async (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    setFormDataError((prevFormData) => ({
      ...prevFormData,
      [name]: "",
    }));
  }

  return (
    <div>
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={"Partner Monetization Settings"} saveText={"Update Settings"} saveMethod={handleStore} />
      <FormContainer>
        <Wrapper className={"w-100"}>
          <MessageHeading text={"Partner Settings"} />
          <MessageLabel text="Monetization View Limit" className="mandatorySimple" />
          <AdminCustomInput type="number" min={0} max={100} id="viewcount_limit" placeHolder={"Enter monetization view limit"} name="viewcount_limit" value={formData?.viewcount_limit} ref={viewCountInputRef} onChange={handleInput} error={formDataError?.viewcount_limit} />
          <MessageLabel text='Amount Per View' />
          <AdminCustomInput type="number" min={0} max={100} id="views_amount" name="views_amount" placeHolder={"Enter amount per view"} value={formData?.views_amount} ref={ViewsAmountInputRef} onChange={handleInput} error={formDataError?.views_amount} />
          <MessageLabel text="Video View Limit" className="mandatorySimple" />
          <AdminCustomInput type="number" min={0} max={100} id="video_viewcount_limit" name="video_viewcount_limit" placeHolder={"Enter video view limit"} value={formData?.video_viewcount_limit} ref={videoViewcountRef} onChange={handleInput} error={formDataError?.video_viewcount_limit} />
        </Wrapper>
      </FormContainer>

    </div>
  )
}

export default PartnerMonetizationSettings

